var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._g({staticClass:"agent",attrs:{"to":{ name: 'users' }}},_vm.$listeners),[_c('v-avatar',{staticClass:"agent__avatar",attrs:{"size":"small","src":_vm.photo}}),_c('div',{staticClass:"agent__name"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }